import { Get, Post } from "domain/infra/data/api";
import CampanhaConstants from "../../infra/data/campanhaConstants";
import ValidationResult from "domain/types/global/validationResult";
import { UltimaOperacaoResponse } from "../../types/aprovarPedido/ultimaOperacaoResponse";

export class AprovarPedidoService {
  constructor() {
  }
  async AprovarPedido(campanhaPedidoResgateId: number, statusAtual: number, usuarioAprovador: string, empresaId: string, status: number, motivo: string): Promise<ValidationResult | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhasUsuario.aprovarResgate, { campanhaPedidoResgateId, statusAtual, usuarioAprovador, empresaId, status, motivo })
  }

  async ReprovarPedido(campanhaPedidoResgateId: number, motivo: string, usuario: string): Promise<ValidationResult | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhasUsuario.reprovarResgate, { campanhaPedidoResgateId, motivo, usuario })
  }

  async GetUltimaOperacao(campanhaPedidoResgateId: number): Promise<UltimaOperacaoResponse | null> {
    const result = await Get<UltimaOperacaoResponse>(CampanhaConstants.apiCampanha.CampanhaPedidoResgate.ultimaOperacao(campanhaPedidoResgateId))
    if (result instanceof Error) {
      return null;
    }
    return result;
  }
}
